import React from 'react';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import BackToStreamButton from '../../Duperbrowse/BackToStreamButton';
import Details from '../../DeviationViews/Details';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import PanelPopup from '../_partials/PanelPopup';
import CentralColumn from '../_partials/CentralColumn';
import DesktopLayout from '../_partials/DesktopLayout';
const DesktopStatusPage = ({ deviation })=>{
    return /*#__PURE__*/ React.createElement(DesktopLayout, {
        deviation: deviation,
        stageContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ArtStage, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(BackToStreamButton, null), /*#__PURE__*/ React.createElement(ActionBar, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(PanelPopup, {
            deviation: deviation,
            actionBarType: "primary"
        })),
        metaContent: /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(Details, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(UserGiftSaleBanner, {
            user: deviation.author
        }))
    });
};
DesktopStatusPage.displayName = 'DesktopStatusPage';
export default DesktopStatusPage;
